/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { environment } from 'utils/environment';


/* --------------- UTILITIES : URLs --------------- */
// set host URL based on dynamic environment variable
let baseURL;
let b2cAPI;
let staticAPI;
let cmsAPI;
let eventsAPI;

// populate hostURL with proper amazon s3 bucket url based on environment
switch (environment) {
    case 'PRODUCTION':
        baseURL = 'insticator.com';
        b2cAPI = 'https://b2c.instiengage.com';
        cmsAPI = 'https://cms.instiengage.com';
        staticAPI = 'https://static.instiengage.com';
        eventsAPI = 'https://event.instiengage.com';
        break;
    case 'DEV':
        // fall through
	case 'LOCALHOST':
        baseURL = 'insticator.com';
        b2cAPI = 'https://b2c.insticator.devenv';
        cmsAPI = 'https://cms.insticator.devenv';
        staticAPI = 'https://d1i85t02k7w8m1.cloudfront.net';
        eventsAPI = 'https://event.hunchme.com';
        break;
    case 'REVIEW':
        baseURL = 'instireviews.com';
        b2cAPI = 'https://b2c.instireviews.com';
        cmsAPI = 'https://cms.instireviews.com';
        staticAPI = 'https://static.instireviews.com';
        eventsAPI = 'https://event.hunchme.com';
        break;
    case 'STAGING':
        // fall through
    default:
        baseURL = 'hunchme.com';
        b2cAPI = 'https://b2c.hunchme.com';
        cmsAPI = 'https://cms.hunchme.com';
        staticAPI = 'https://static.hunchme.com';
        eventsAPI = 'https://event.hunchme.com';
}

// store URLs for export
const url = {
	image: {
		app: `${staticAPI}/files/images/embed4.0/app`,
		client: ``,
		emoji: `https://twemoji.maxcdn.com/72x72` // comes from https://twitter.github.io/twemoji/preview.html
	},
	company: `https://www.${baseURL}`,
	api: {
		contents: `${cmsAPI}/v3/contents`,
        getQuestionnaire: `${cmsAPI}/v1/survey`,
        questionResponses: `${b2cAPI}/v1/contentengage`,
    },
    events: eventsAPI
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { url };
